import { Course, MarketingKitItem, isMarketingKitItem } from "@vixi/types";
import { QueryClient, queryOptions } from "@tanstack/react-query";
import { courseBaseByIdQueryOptions } from "../courses/courseByIdQuery";
import { CHARACTER_TYPE } from "@vixi/types";
import { assert, sleepAsync } from "@vixi/utils";

export const marketingKitIndex = {
  [CHARACTER_TYPE.INSTAGRAM_POST_CHARACTER]: 0,
  [CHARACTER_TYPE.INSTAGRAM_STORY_CHARACTER]: 1,
  [CHARACTER_TYPE.LINKEDIN_POST_CHARACTER]: 2,
};

// const mockResponse: Avatar[] = [
//   {
//     id: 160,
//     url: "https://api.coursemaker.vixiapp.com/Attachments/avatars/9f527374-2ea6-417f-8012-2d1a2e8cb991/2d3c1293-f07c-4782-ae2a-6e2e66faec98.jpg",
//     characterType: 0,
//   },
//   {
//     id: 170,
//     url: "/Attachments/avatars/dc3c99eb-d737-4bd3-9f94-0ef7ddaef300/9884378f-fd81-4389-8fbd-ff19682591c0.png",
//     characterType: 3,
//   },
//   {
//     id: 171,
//     url: "/Attachments/avatars/73a5b625-8781-41ef-b133-04d2a0778a5f/b18b9557-82d3-41c6-8391-80729ffe3e35.png",
//     characterType: 2,
//   },
//   {
//     id: 172,
//     url: "/Attachments/avatars/c13f07b3-7f3a-4d73-a308-01ed26190866/64b59ba9-e215-4575-be33-3971a3024ed3.png",
//     characterType: 1,
//   },
// ];

const getMarketingKit = async (queryClient: QueryClient, courseId: NonNullable<Course["id"]>) => {
  assert(!!courseId, "courseId must be defined to fetch marketing kit");

  const course = await queryClient.ensureQueryData(
    courseBaseByIdQueryOptions(queryClient, courseId),
  );
  const marketingKitItems = course.courseCharacters?.filter(isMarketingKitItem) ?? [];

  const marketingKit: (MarketingKitItem | undefined)[] = Array(
    Object.keys(marketingKitIndex).length,
  ).fill(undefined);

  marketingKitItems.forEach((item) => {
    const index = marketingKitIndex[item.characterType];
    if (index !== undefined) {
      marketingKit[index] = item;
    }
  });

  // Add delay to make sure images have been processed on back end and are being served correctly
  await sleepAsync(2000);

  return marketingKit;
};

// const getMockMarketingKit = () => {
//   const res: (MarketingKitItem | undefined)[] = Array(Object.keys(marketingKitIndex).length).fill(
//     undefined,
//   );

//   let callCount = -2;
//   const marketingKit = mockResponse
//     .filter(isMarketingKitItem)
//     .sort((a, b) => marketingKitIndex[a.characterType] - marketingKitIndex[b.characterType]);

//   return async (..._: any[]) => {
//     if (callCount >= 0 && callCount < res.length) {
//       res[callCount] = marketingKit[callCount];
//     }
//     callCount++;
//     return [...res];
//   };
// };

// const queryFn = isMock("marketingKit") ? getMockMarketingKit() : getMarketingKit;
const queryFn = getMarketingKit;

export const courseMarketingKitQueryOptions = (
  queryClient: QueryClient,
  courseId?: NonNullable<Course["id"]>,
) =>
  queryOptions({
    queryKey: ["course", "marketing-kit", courseId],
    queryFn: async ({ queryKey: [, , courseId] }) => {
      assert(typeof courseId === "number", "courseId must be defined to fetch marketing kit");

      return queryFn(queryClient, courseId);
    },
    enabled: courseId !== undefined,
  });
